import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { FillingStationType } from '../../../../Models/fillingStationType'
import fillingStationService from '../../../../Services/fillingStationService'
import { HorizontalLoader } from '../../../../Components'
import { DateTimeFormatter } from '../../../../Helpers/DateTimeFormatter'
import Swal from 'sweetalert2'
import './Fillingstations.scss'

const FillingStationDetails = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [station, setStation] = useState<FillingStationType | null>(null)
  const [loading, setLoading] = useState(false)

  const getStation = async () => {
    if (!id) return
    setLoading(true)
    try {
      const response = await fillingStationService.getById(id)
      setStation(response.data.data)
    } catch (error) {
      console.error('Error fetching filling station:', error)
    } finally {
      setLoading(false)
    }
  }

  const deleteStation = async () => {
    if (!id) return
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won"t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          await fillingStationService.delete(id)
          Swal.fire('Deleted!', 'The filling station has been deleted.', 'success')
          navigate('/filling-stations')
        } catch (error) {
          console.error('Error deleting filling station:', error)
          Swal.fire('Error!', 'Something went wrong.', 'error')
        } finally {
          setLoading(false)
        }
      }
    })
  }

  useEffect(() => {
    getStation()
  }, [id])

  if (loading) {
    return <HorizontalLoader />
  }

  if (!station) {
    return <p>Station not found</p>
  }

  return (
    <div className='filling-station'>
      <div className='container mt-4'>
        <div className='card border-0'>
          <div className='card-header  border-0'>
            <div className='row h-100'>
              <div className='col-6 my-auto'>
                <h5 className='card-title'>
                  {station.businessName} - {station.branchName}
                </h5>
              </div>
              <div className='col-6 text-end my-auto'>
                <Link to={`/filling-stations/edit/${id}`} className='btn btn-primary me-2'>
                  Edit
                </Link>
                <button className='btn btn-danger' onClick={deleteStation}>
                  Delete
                </button>
              </div>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-md-6'>
                <p>
                  <strong>Address:</strong> {station.address}
                </p>
                <p>
                  <strong>City:</strong> {station.city}
                </p>
                <p>
                  <strong>State:</strong> {station.state}
                </p>
                <p>
                  <strong>Latitude:</strong> {station.latitude}
                </p>
                <p>
                  <strong>Longitude:</strong> {station.longitude}
                </p>
              </div>
              <div className='col-md-6'>
                <p>
                  <strong>Account Manager:</strong> {station.accountManager?.firstName ?? ''}{' '}
                  {station.accountManager?.lastName ?? ''}
                </p>
                <p>
                  <strong>Fuel Facts ID:</strong> {station.fuelFactsId}
                </p>
                <p>
                  <strong>Pumps:</strong> {station.pumps.join(', ')}
                </p>
                <p>
                  <strong>Opening Time:</strong> {station.openingTimeHour}
                </p>
                <p>
                  <strong>Closing Time:</strong> {station.closingTimeHour}
                </p>
                <p>
                  <strong>Date Created:</strong> {DateTimeFormatter(station.createdAtISO8601)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FillingStationDetails
